import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { logout } from "../store/slices/authSlice";
import NavigationBar from "./NavBar";

const MainLayoutLogged = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    dispatch(logout());
    navigate("/login", { replace: true });
  };

  return (
    <div className="admin-shell">
      <NavigationBar />
      <main className="admin-main">
        <header className="admin-topbar">
          <div>
            <p className="text-secondary mb-0 small">Welcome back</p>
            <strong>{localStorage.getItem("name") || "Admin"}</strong>
          </div>
          <Button variant="outline-danger" onClick={handleLogout}>
            Logout
          </Button>
        </header>
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayoutLogged;
